import "./index.scss";

/**
 * @param variant Accept 'primary' or 'secondary' values.
 */
export const Loader = ({ variant = "primary", id = "loader" }) => {
  return (
    <div className={`loader ${variant}`} id={id} data-testid="loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
